import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { fetchDataIfNeeded, invalidateUsercardCountData } from '../../actions/UsercardCountAction';
import BigBreadcrumbs from '../../components/layout/navigation/components/BigBreadcrumbs.jsx'
import WidgetGrid from '../../components/layout/widgets/WidgetGrid.jsx'
import JarvisWidget from '../../components/layout/widgets/JarvisWidget.jsx'
import Datatable from '../../components/tables/Datatable.jsx'
import ChartJsGraph from '../../components/graphs/chartjs/ChartJsGraph.jsx'

class UsercardCount extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      isActivityUser: this.props.isActivityUser
    };

    this.handleActivityUserChange = this.handleActivityUserChange.bind(this);
  }
  componentDidMount() {
    this.props.dispatch(fetchDataIfNeeded(this.state.isActivityUser));
  }

  handleActivityUserChange(event){

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.setState({
      isActivityUser: value
    });

    this.props.dispatch(invalidateUsercardCountData());
    this.props.dispatch(fetchDataIfNeeded(value));

  }

  render() {

    if (this.props.isFetching && this.props.data.length == 0) {
      return <p>Loading...</p>
    }

    return <div id="content">
                <div className="row">
                    <BigBreadcrumbs items={['Table', 'Data Tables']} icon="table"
                                    className="col-xs-12 col-sm-7 col-md-7 col-lg-4"/>
                </div>

                <WidgetGrid>

                    <div className="row">
                        <article className="col-sm-6">

                            <JarvisWidget editbutton={false} color="blueDark">
                                <header>
                                    <span className="widget-icon"> <i className="fa fa-table"/> </span>
                                    <h2>カード登録枚数</h2>
                                      <div className="widget-toolbar hidden-mobile">
                                        <span className="onoffswitch-title">Installed User</span>
                                        <span className="onoffswitch">
                                            <input type="checkbox" name="isActivityUser" className="onoffswitch-checkbox"
                                                  id="myonoffswitch"
                                                   checked={this.state.isActivityUser}
                                                   onChange={this.handleActivityUserChange}
                                                   />
                                                <label className="onoffswitch-label" htmlFor="myonoffswitch"> <span
                                                    className="onoffswitch-inner" data-swchon-text="YES"
                                                    data-swchoff-text="NO"/> <span
                                                    className="onoffswitch-switch"/> </label>
                                        </span>
                                      </div>
                                </header>
                                <div>
                                    <div className="widget-body no-padding">

                                        <Datatable
                                            data = {this.props.data}
                                            options={{
                                                columns: [
                                                  {data: "card_count"},
                                                  {data: "user_count"},
                                                  {data: "percentage"}
                                                ],
                                                buttons: [
                                                    {
                                                        extend: 'csv',
                                                        bom: true
                                                    }, 
                                                    'copy', 'excel', 'pdf'
                                                ],
                                                "pageLength": 20
                                            }}
                                            className="table table-striped table-bordered table-hover"
                                            width="100%">
                                            <thead>
                                            <tr>
                                                <th >カード登録数</th>
                                                <th >ユーザー数</th>
                                                <th >比率</th>
                                            </tr>
                                            </thead>
                                        </Datatable>

                                    </div>
                                </div>
                            </JarvisWidget>
                        </article>

                        <article className="col-sm-6">

                          <JarvisWidget editbutton={false}>
                              <header>
                                  <span className="widget-icon"> <i className="fa fa-bar-chart-o"/> </span>
                                  <h2>Pie Chart</h2>
                              </header>
                              <div>
                                  <div className="widget-body">
                                      <ChartJsGraph type="pie" data={this.props.graphData} />
                                  </div>
                              </div>
                          </JarvisWidget>
                        </article>

                    </div>

                </WidgetGrid>
            </div>
  }
}

const mapStateToProps = (state) => {

  const { usercardCount } = state;
  const { isActivityUser, isFetching, lastUpdated, didInvalidate } = usercardCount

  let sumUser = usercardCount.data.reduce(function(acc, val) {
    return acc + val.user_count;
  }, 0);

  let newData = usercardCount.data.map((obj) => {

    return {
      ...obj,
      percentage:(obj.user_count * 100 / sumUser).toFixed(2) + '%'
    };
  });

  var colorSet = ["#278ECF", "#4BD762", "#FFCA1F", "#FF9416", "#D42AE8",
                  "#535AD7", "#FF402C", "#83BFFF", "#6EDB8F", "#FFE366",
                  "#FFC266", "#D284BD", "#8784DB", "#FF7B65", "#CAEEFC",
                  "#9ADBAD", "#FFF1B2", "#FFE0B2", "#FFBEB2", "#B1AFDB"]
                  .slice(0, usercardCount.data.length+1);

  if(!isFetching){

    return {
      data: newData,
      graphData: {
        labels: usercardCount.data.map((val) => val.card_count),
        datasets: [
          {
            data: usercardCount.data.map((val) => val.user_count),
            backgroundColor: colorSet,
            hoverBackgroundColor: colorSet
          }
        ]
      },
      isFetching: isFetching,
      isActivityUser: isActivityUser
    }
  }else{
    return {}
  }
}

export default connect(mapStateToProps)(UsercardCount);



// WEBPACK FOOTER //
// ./src/pages/collectdata/UsercardCount.js